import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TermsCopyrightPurchase } from './TermsCopyrightPurchase';
import { TermsCopyrightCompliance } from './TermsCopyrightCompliance';

type Props = {
  type: 'Purchase' | 'Compliance';
  onClose: () => void;
}

const DrawerContent = ({ type, onClose }: Props) => {
  const TermsByType = () => {
    switch (type) {
      case 'Purchase':
        return <TermsCopyrightPurchase/>;
      case 'Compliance':
        return <TermsCopyrightCompliance/>;
      default:
        return <TermsCopyrightPurchase/>;
    }
  };

  return (
    <>
    <Stack direction="row" mb={2} justifyContent="space-between">
      <Typography variant="h5" id={'scroll-dialog-title'} component="h1">
        Terms & Conditions
      </Typography>
      <Box>
        <IconButton
          onClick={onClose}
          sx={{ transform: 'translate(12px, -8px)' }}
        >
          <CloseIcon sx={{ color: 'black' }}/>
        </IconButton>
      </Box>
    </Stack>
    <Box id="modal">
      <Box
        sx={{
          overflow: 'scroll',
          height: '62vh',
          p: 2,
          bgcolor: 'rgba(61, 177, 87, .15)',
        }}
      >
        <TermsByType />
      </Box>
      <Button
        sx={{ float: 'right', mt: 3, mb: { xs: 3, sm: 0 }, width: { xs: '100%', sm: '105px' } }}
        variant="contained"
        id={'terms-agree-button'}
        onClick={onClose}
      >
        Close
      </Button>
    </Box>
  </>
  )};

export default DrawerContent;
